import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { Button } from "@progress/kendo-react-buttons";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import AlertBox from "../../components/common/AlertBox";
import {
  GridCellProps,
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
} from "@progress/kendo-react-grid";
import {
  HeaderThElement,
  PagerTargetEvent,
} from "@progress/kendo-react-data-tools";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import { MdDelete } from "react-icons/md";
import { Switch } from "@progress/kendo-react-inputs";
import AppDrawer from "../../components/drawer/Drawer";
import ButtonCreate from "../../components/drawer/ButtonCreate";
import ButtonEdit from "../../components/drawer/ButtonEdit";
import { ACTIVEINACTIVE_TYPE } from "../../_contstants/common";
import {
  LeadSourceActiveInactive,
  deleteLeadSource,
  getAllLeadSource,
} from "./services/leadsource.services";
import CreateLeadSource from "./CreateLeadSource";
import { clearLeadsourceID, setLeadsourceID } from "./leadsourceSlice";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import { checkAcessRights } from "../../_helper/helper";

const LeadSource: React.FC = () => {
  const dispatch = useAppDispatch();
  const isDrawerOpen = useAppSelector((state) => state.drawer.open);
  const drawerName = useAppSelector((state) => state.drawer.name);
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  useEffect(() => {
    dispatch(getAllLeadSource());
    return () => {
      dispatch(closeDialog());
    };
  }, []);
  return (
    <>
      <DeleteLeadSourceDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Lead Source List
          </Typography.h4>
          {isAddAccess && (
            <ButtonCreate
              label="Create Lead source"
              drawerName="leadsourceForm"
            />
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <LeadSourceGridComponent />
        </GridLayoutItem>
        {isDrawerOpen && drawerName === "leadsourceForm" && (
          <AppDrawer>
            <CreateLeadSource />
          </AppDrawer>
        )}
      </GridLayout>
    </>
  );
};

/* This function is called when the delete button is clicked */
const DeleteLeadSourceDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const LeadSourceID = useAppSelector((state) => state.leadsource?.LeadSorceID);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteLeadSource(ID));
      if (response.payload?.Data.Status === 200) {
        dispatch(getAllLeadSource());
        dispatch(closeDialog());
        dispatch(clearLeadsourceID());
      } else {
        dispatch(getAllLeadSource());
        dispatch(closeDialog());
        dispatch(clearLeadsourceID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteLeadSource" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete LeadSource?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this LeadSource?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(LeadSourceID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const LeadSourceGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const LeadSourceList = useAppSelector(
    (state) => state.leadsource.LeadSorceList
  );
  const loading = useAppSelector((state) => state.leadsource.loading);
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All" ? LeadSourceList.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  if (loading) return <LoadingPanel gridRef={gridRef} />;

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteLeadSource"));
      dispatch(setLeadsourceID(ID));
    };
    return (
      <td
        className="action-td"
        style={{
          ...props.style,
        }}
      >
        {isEditAccess && (
          <ButtonEdit
            ID={props.dataItem.LeadSourceGUID}
            drawerName="leadsourceForm"
            title="Edit"
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
themeColor="error"
            onClick={() =>
              handleOpenDeleteDialog(props.dataItem.LeadSourceGUID)
            }
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className="table-header"
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const MyActiveInActtiveCommandCell = (props: GridCellProps) => {
    const [IsActive, setIsActive] = useState<boolean>(props.dataItem.IsActive);
    const handleActiveInActive = () => {
      setIsActive(!IsActive);
      const data = {
        LeadSourceGUID: props.dataItem.LeadSourceGUID,
        IsActive: !IsActive,
        OperationType: ACTIVEINACTIVE_TYPE,
      };
      dispatch(LeadSourceActiveInactive(data)).then((response: any) => {
        if (response.payload?.Status === 200) {
          dispatch(getAllLeadSource());
        } else {
          dispatch(getAllLeadSource());
        }
      });
    };

    return (
      <td style={{ textAlign: "center" }}>
        <Switch
          name="IsActive"
          checked={IsActive}
          disabled={isEditAccess ? false : true}
          onChange={handleActiveInActive}
          size="small"
        />
      </td>
    );
  };

  return (
    <>
      {LeadSourceList && LeadSourceList.length ? (
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 152px)" }}
 className="responsive-table"
          filterable={true}
          filter={filter}
          data={
            filter
              ? filterBy(LeadSourceList, filter).slice(
                  page.skip,
                  page.take + page.skip
                )
              : LeadSourceList.slice(page.skip, page.take + page.skip)
          }
          onFilterChange={handleFilterChange}
          skip={page.skip}
          take={page.take}
          total={LeadSourceList.length}
          pageable={{
            buttonCount: 5,
            pageSizes: [5, 10, 15, "All"],
            pageSizeValue: pageSizeValue,
            type: "input",
          }}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column
            field="LeadSource"
            title="Lead Source"
            cell={(props: any) => (
              <td className="hoverableName">
                {isEditAccess ? (
                  <ButtonEdit
                    ID={props.dataItem.LeadSourceGUID}
                    drawerName="leadsourceForm"
                    label={props.dataItem?.LeadSource}
                  />
                ) : (
                  props.dataItem?.LeadSource
                )}
              </td>
            )}
          />
          <Column
            field="LeadSourceGUID"
            title="Status"
            cell={MyActiveInActtiveCommandCell}
            width={"90px"}
            filterable={false}
            locked={true}
          />
          {(isDeleteAccess || isEditAccess) && (
            <Column
              field="LeadSourceGUID"
              title="Actions"
              cell={MyEditCommandCell}
              width={"110px"}
              filterable={false}
            />
          )}
        </KendoGrid>
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default LeadSource;
